module.exports = __webpack_public_path__ + "static/img/naturalCircle1.5be3991.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle1.svg
// module id = ZOD0
// module chunks = 1